import i18n from 'i18next';

import addToast from './addToast';

export default () => {
  addToast(
    {
      body: i18n.t('error-message-body', 'Please contact an administrator.'),
      title: i18n.t('error-message-title', 'There’s been an error processing your request.'),
    },
    'error',
  );
};
